import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import LoadingScreen from '../../LoadingScreen/LoadingScreen';
import { useMyPoolsPageContext } from '../context/MyPoolsPageContext';
import useNavigateToTop from '../../../hooks/general/useNavigateToTop';
import MyPoolsCard from '../MyPoolsCard/MyPoolsCardNew';
import { useGetMyPoolsData } from '../../../hooks/pools/useGetMyPoolsData';

const MyActivePools = ({active=false}) => {
    const { myUserId, userData, gamesData } = useMyPoolsPageContext();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md')); // Mobile screens
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm')); // Very small screens
    const navigateToTop = useNavigateToTop();

    const [dataLoading, setDataLoading] = useState(true);

    const { mutate: fetchMyPoolsData, data: myPoolsData, loading: myPoolsLoading, error: myPoolsError } = useGetMyPoolsData();

    // Use Effect to get my pools data
    useEffect(() => {
        fetchMyPoolsData(myUserId);
        setDataLoading(false);
    }, [fetchMyPoolsData, myUserId]);
    
    const userActiveGames = userData?.Games?.filter(game =>
        game.masterPoolId && game.status === (active ? 'active' : 'completed')
    );

    // Reverse the order of games
    userActiveGames?.reverse();

    if (!userActiveGames || userActiveGames?.length === 0) {
        return (
            <Box sx={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                padding: '20px' 
            }}>
                <Typography variant="h6">No active pools found.</Typography>
            </Box>
        );
    }

    if (dataLoading) {
        return <LoadingScreen />;
    }

    // Determine if we should center the grid items
    const singleCard = userActiveGames?.length === 1;

    return (
        <>
            <Box
                sx={{
                    maxWidth: '1312px',
                    margin: '0 auto',
                    border: isMobile ? 'none' : '1px solid #CCCCCC',
                    padding: isMobile ? '0px' : '32px 32px 42px 32px',
                }}
            >
                <Typography
                    sx={{
                        fontSize: isMobile ? '24px' : '32px',
                        fontWeight: 700,
                        padding: isMobile ? '0px 16px 0px 16px' : '0px 0px 0px 0px',
                        textAlign: 'left',
                        marginBottom: '32px',
                        width: isMobile ? '311px' : '100%',
                        margin: isMobile ? '0 auto' : '0',
                    }}
                >
                    {active ? 'Active' : 'Completed'} Pools
                </Typography>
                
                <Box sx={{ 
                    display: 'flex',
                    justifyContent: singleCard ? 'center' : 'flex-start',
                    width: '100%'
                }}>
                    <Grid 
                        container 
                        spacing={4} 
                        sx={{ 
                            width: '100%',
                            margin: '0', // Override default negative margins
                            justifyContent: singleCard ? 'center' : 'flex-start'
                        }}
                    >
                        {userActiveGames?.map((game, index) => (
                            <Grid 
                                item 
                                xs={12} 
                                md={singleCard ? 6 : 6} 
                                lg={singleCard ? 4 : 4} 
                                key={index}
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    paddingTop: '32px !important', // Override Material UI's default padding
                                    paddingLeft: '0px !important', // Override Material UI's default padding
                                }}
                            >
                                <MyPoolsCard 
                                    gameData={game}
                                    myPoolsData={myPoolsData}
                                    active={active}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Box>
        </>
    );
};

export default MyActivePools;